import { AppState, AuthorPageAbuDhabiAppState } from '../../../initialStateRegistration';
import { AuthorPageSectionName } from '../authorPage.reducer';

const getAuthorPage = (state: AppState) => (state as AuthorPageAbuDhabiAppState).template;

export const getImage = (state: AppState) => getAuthorPage(state).image;

export const getName = (state: AppState) => getAuthorPage(state).name;

export const getByline = (state: AppState) => getAuthorPage(state).byline;

export const getSocialButtons = (state: AppState) => getAuthorPage(state).socialButtons;

export const getBio = (state: AppState) => getAuthorPage(state).bio;

const getAuthorPageSection = (state: AppState) => getAuthorPage(state)[AuthorPageSectionName];

export const getArticles = (state: AppState) => getAuthorPageSection(state).articles;

export const getSectionTitle = (state: AppState) => getAuthorPageSection(state).sectionTitle;

export const getShowMorePaginationURLByKey = (key: typeof AuthorPageSectionName) => (state: AppState) => getAuthorPage(state)[key].showMorePaginationURL;

export const getShowMorePaginationText = (state: AppState) => getAuthorPageSection(state).showMorePaginationText;
